import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import flow from "lodash/fp/flow";
import constants from "../../core/constants";

class ContractorsPageTransform {
  constructor() {
    "ngInject";

    this.item = {
      title: "Contractor",
      state: "contractor",
    };

    this.fields = [
      { title: "Contractor", name: "contractorName" },
      { title: "City", name: "cityName" },
    ];

    this.filters = [
      {
        name: "search",
        title: "Search",
        icon: "search",
        isSearch: true,
        resource: "Contractors",
        state: "contractor",
        size: 30,
      },
    ];

    this.addOptions = {
      title: "Add New Contractor",
      icon: "add",
      fields: [
        {
          resource: "City",
          name: "city",
          title: "City",
          isResource: true,
          isRequired: true,
        },
        {
          name: "name_i18n",
          title: "Contractor's Name",
          isI18nText: true,
          isRequired: true,
        },
        {
          name: "phone_data",
          title: "Contractor's Contact Number",
          type: "number",
          isPhoneObject: true,
          isRequired: true,
          pattern: constants.RegExp.phone,
          patternErrorMsg:
            "Contractor's Contact Number must be at least 10 digits",
        },
        {
          name: "owner_name",
          title: "Owner's Name",
          isI18nText: true,
          isRequired: true,
        },
        {
          name: "owner_phone_data",
          title: "Owner's Contact Number",
          type: "number",
          isPhoneObject: true,
          isRequired: true,
          pattern: constants.RegExp.phone,
          patternErrorMsg: "Owner's Contact Number must be at least 10 digits",
        },
        {
          name: "email",
          title: "Owner's Email",
          type: "email",
          isText: true,
          isRequired: true,
          pattern: constants.RegExp.email,
          patternErrorMsg: "This is not a valid email address",
        },
        {
          name: "is_tax_filer",
          title: "Tax Filer",
          value: null,
          list: "taxFilers",
          isRequired: false,
        },
      ],
    };
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const format = (item) => {
      item.contractorName = item.name_i18n.en;
      item.cityName = item.city.name;
      return item;
    };
    return map(flow([getSource, format]))(data);
  }
}

export default ContractorsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/contractors/contractors.transforms.js